"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AtmoCollectors = void 0;
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const ResourceType_1 = require("../../ResourceType");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const Resources_1 = require("../../Resources");
const AddResourcesToCard_1 = require("../../deferredActions/AddResourcesToCard");
const Card_1 = require("../Card");
const Size_1 = require("../render/Size");
const CardRenderer_1 = require("../render/CardRenderer");
class AtmoCollectors extends Card_1.Card {
    constructor() {
        super({
            cost: 15,
            name: CardName_1.CardName.ATMO_COLLECTORS,
            cardType: CardType_1.CardType.ACTIVE,
            resourceType: ResourceType_1.ResourceType.FLOATER,
            metadata: {
                description: 'Add 2 floaters to ANY card.',
                cardNumber: 'C03',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Add one floater here.', (eb) => {
                        eb.empty().startAction.floaters(1).or(Size_1.Size.SMALL);
                    }).br;
                    b.action('Spend 1 floater here to gain 2 titanium, or 3 energy, or 4 heat.', (eb) => {
                        eb.floaters(1).startAction.titanium(2).digit.slash(Size_1.Size.SMALL).energy(3).digit.slash(Size_1.Size.SMALL).heat(4).digit;
                    }).br;
                    b.floaters(2).asterix();
                }),
            },
        });
        this.resourceCount = 0;
    }
    canAct() {
        return true;
    }
    action(player) {
        if (this.resourceCount < 1) {
            player.addResourceTo(this, 1);
            return undefined;
        }
        return new OrOptions_1.OrOptions(new SelectOption_1.SelectOption('Remove 1 floater to gain 2 titanium', 'Remove floater', () => {
            this.resourceCount--;
            player.addResource(Resources_1.Resources.TITANIUM, 2, { log: true });
            return undefined;
        }), new SelectOption_1.SelectOption('Remove 1 floater to gain 3 energy', 'Remove floater', () => {
            this.resourceCount--;
            player.addResource(Resources_1.Resources.ENERGY, 3, { log: true });
            return undefined;
        }), new SelectOption_1.SelectOption('Remove 1 floater to gain 4 heat', 'Remove floater', () => {
            this.resourceCount--;
            player.addResource(Resources_1.Resources.HEAT, 4, { log: true });
            return undefined;
        }), new SelectOption_1.SelectOption('Add 1 floater to this card', 'Add floater', () => {
            player.addResourceTo(this, { log: true });
            return undefined;
        }));
    }
    play(player) {
        player.game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, ResourceType_1.ResourceType.FLOATER, { count: 2 }));
        return undefined;
    }
}
exports.AtmoCollectors = AtmoCollectors;
//# sourceMappingURL=AtmoCollectors.js.map